jQuery(".cart-item.cart-free-item a").attr("href", "#");

// function customAddFreeBag(is_add_to_cart, productID, productQTY){  
  
//   async function removeItem(variantId, quantity, is_add_to_cart, productID, productQTY) {
//     if(document.getElementById("hide_6654809309269")){
//       document.getElementById("hide_6654809309269").click();
//       console.log('bag need to remove');
//     }
    
//   }

//   async function addItem(variantId, quantity, is_add_to_cart, productID, productQTY) {
//     $(".quantity__button, .cart-remove-button"). attr("disabled", true);
//     if(document.getElementById("ProductSubmitButton-template--14865680629845__main_free")){
//       document.getElementById("ProductSubmitButton-template--14865680629845__main_free").click();
//     } 
//     console.log('bag need to add');
//     setTimeout(function(){
//        $(".quantity__button, .cart-remove-button"). attr("disabled", false);
//      }, 200);
//   }

//   async function updateItem(variantId, quantity, is_add_to_cart, productID, productQTY) {
//       console.log('need to update cart', variantId);  
//     jQuery.post(window.Shopify.routes.root + 'cart/update.js',
//       "updates["+variantId+"]=1"
//     );
//   }
  
//   jQuery(".cart-item.cart-free-item a").attr("href", "#");

// var product_id_to_check1 = 6619612971093; // clicq chair
// var product_id_to_check2 = 6654809309269; // free bag
// //free bag ids 
// var product_var_id_to_add_11 = 39627595677781; // Free Bag - 2 PK , When 2 Cliq Chairs
// var product_var_id_to_add_21 = 40688681222229; // Free Bag - 2 SLING, When 2 Cliq Chairs
// var product_var_id_to_add_31 = 39627595710549; // Free Bag - 4PK , When 3 or 4 Cliq Chairs
// var product_var_id_to_add_41 = 39627595743317; // Free Bag - 6 PK, When 5 or more Cliq Chair
// // if any of them is not available then go for previous of them and check availability. 
// var url1 = '/cart.json'; 
// fetch(url1)
//     .then(res => res.json()) 
//     .then((out) => { 
//        var items = out.items; 
//        var totalQty = 0;
//       var is_free_bag = false;
//       var is_click_chair = false;
//       var product_var_id_to_add_11_sku = false;
//       var product_var_id_to_add_21_sku = false;
//       var product_var_id_to_add_31_sku = false;
//       var product_var_id_to_add_41_sku = false;
      
//        if(items.length > 0){
//          items.forEach(function(item){
//             var product_id = item.product_id;
//             var quantity = item.quantity;
//             //count total qty 
           
//             if(product_id == product_id_to_check1){
//               totalQty = totalQty + quantity;                              
//               is_click_chair = true;
//             }

//              if(product_id == product_id_to_check2){
//                is_free_bag = true;
//                 if(item.id==product_var_id_to_add_11){
//                   product_var_id_to_add_11_sku = true;
//                 }
//                if(item.id==product_var_id_to_add_21){
//                   product_var_id_to_add_21_sku = true;
//                 }
//                if(item.id==product_var_id_to_add_31){
//                   product_var_id_to_add_31_sku = true;
//                 }
//                if(item.id==product_var_id_to_add_41){
//                   product_var_id_to_add_41_sku = true;
//                 }
               
//                if(quantity>1){
//                   updateItem(item.id);
//                 }
//              }
            
//           }); 
         
//             // free bag product 
//              var availableVars = [] ;
//              if(freeProductData != undefined || freeProductData != null){
//                 var variants = freeProductData.variants;
//                 if(variants.length > 0){
//                  variants.forEach(function(item){
//                    var var_available = item.available;
//                    var var_id = item.id;
//                    if(var_available){
//                      availableVars.push(var_id);  
//                    }  
//                    //console.log('datanew',item);
//                  });
//                 }
              
//             // validations
//             var proceedVar = null; 
//             var quantity = totalQty; 
//                if(quantity == 2){
//                   if(availableVars.includes(product_var_id_to_add_11)){
//                     proceedVar = product_var_id_to_add_11;   
//                     if(product_var_id_to_add_11_sku==false){
//                       removeItem();
//                     }
//                   } else if (availableVars.includes(product_var_id_to_add_21)) {
//                     proceedVar = product_var_id_to_add_21;   
//                     if(product_var_id_to_add_21_sku==false){
//                       removeItem();
//                     }
//                   } else if (availableVars.includes(product_var_id_to_add_31)) {
//                     proceedVar = product_var_id_to_add_31;   
//                     if(product_var_id_to_add_31_sku==false){
//                       removeItem();
//                     }
//                   }    
//                   console.log('proceed 2 ',quantity,'proceedVar:',proceedVar);                 
                 
//                } else if (quantity == 3 || quantity == 4) {
//                   if (availableVars.includes(product_var_id_to_add_31)) {
//                     proceedVar = product_var_id_to_add_31;   
//                     if(product_var_id_to_add_31_sku==false){
//                       removeItem();
//                     }
//                   }
//                    else if (availableVars.includes(product_var_id_to_add_41)) {
//                     proceedVar = product_var_id_to_add_41;  
//                     if(product_var_id_to_add_41_sku==false){
//                       removeItem();
//                     }
//                   } else if (availableVars.includes(product_var_id_to_add_11)) {
//                     proceedVar = product_var_id_to_add_11;  
//                     if(product_var_id_to_add_11_sku==false){
//                       removeItem();
//                     }
//                   } else if (availableVars.includes(product_var_id_to_add_21)) {
//                     proceedVar = product_var_id_to_add_21;   
//                     if(product_var_id_to_add_21_sku==false){
//                       removeItem();
//                     }
//                   } 
//                    console.log('proceed 3,4 ',quantity,'proceedVar:',proceedVar);
                 
//                } else if (quantity == 5 || quantity > 5) {
//                   if (availableVars.includes(product_var_id_to_add_41)) {
//                     proceedVar = product_var_id_to_add_41;
//                     if(product_var_id_to_add_41_sku==false){
//                       removeItem();
//                     }
//                   }  else if (availableVars.includes(product_var_id_to_add_31)) {
//                     proceedVar = product_var_id_to_add_31;  
//                     if(product_var_id_to_add_31_sku==false){
//                       removeItem();
//                     }
//                   }  else if (availableVars.includes(product_var_id_to_add_11)) {
//                     proceedVar = product_var_id_to_add_11;   
//                     if(product_var_id_to_add_11_sku==false){
//                       removeItem();
//                     }
//                   } else if (availableVars.includes(product_var_id_to_add_21)) {
//                     proceedVar = product_var_id_to_add_21;  
//                     if(product_var_id_to_add_21_sku==false){
//                       removeItem();
//                     }
//                   }
//                    console.log('proceed 5, more ',quantity,'proceedVar:',proceedVar);
                 
//                }

//                if(quantity<2){
//                   removeItem();
//                 }

               
//                  setTimeout(function(){
//                    console.log('SKU update', proceedVar);
  
//                    jQuery("#product-form-template--14865680629845__main_free .product-variant-id").val(proceedVar); 
                   
//                    if(proceedVar != null && is_free_bag==false){
//                      addItem(proceedVar, 1);                      
//                    }

//                    if(is_click_chair==false){
//                      removeItem();
//                     }
//                  },500);               
                
//              }     
         
//          //console.log('totalQty: ',totalQty);  
//        } 
//        //console.log(items.length);  
//         //console.log('data JSON! ', out); 
//     }) 
//     .catch(err => { throw err });      
// }
class CartRemoveButton extends HTMLElement {  
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
      if(typeof initSP === 'function'){
        initSP();
      }
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    console.log('cartupdate1',routes.cart_url);
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, event.target.nextElementSibling.id);
  }

  onCartUpdate() {
    document.dispatchEvent(new Event('init:sp'));

   /* if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    } */
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, productID) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        console.log('cartupdate5');
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => { 
        this.disableLoading(line);
        if(typeof initSP === 'function'){
          initSP();
        }
        document.dispatchEvent(new Event('sp_checked'))
      });     
      
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    console.log('cartupdate4');
    var setIntervalEl = setInterval(function(){
      var contSh = document.querySelector('.cart-drawer__empty-content > a');
      if(contSh != null){
          contSh.onclick = function(e){
              e.preventDefault();
            if(document.querySelector('.drawer.is-empty') != null){
              document.querySelector('.drawer.is-empty').classList.remove('active');
              document.body.classList.remove('overflow-hidden');    
            }  
          }
         clearInterval(setIntervalEl);
      }
    },100);
  
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
